import LtVideo from '@/components/LtVideo';
import { customCssClasses } from '@lemontaps/lib/constants/profile-page/customCssClassNames';
import { UrlsBoxItemVideo } from '@lemontaps/lib/types/api';

type Props = UrlsBoxItemVideo;

export default function VideoItem({ src, text }: Props) {
  return (
    <LtVideo
      label={text}
      embedUrl={src}
      sx={{
        marginBottom: 2,
        width: '100%',
      }}
      videoClassName={customCssClasses.filesBox.videoItem.className}
      labelClassName={customCssClasses.filesBox.videoItemText.className}
    />
  );
}
